// check if next js server
const isServer = typeof window === 'undefined';

const systemDarkMode = !isServer
  ? window?.matchMedia('(prefers-color-scheme: dark)').matches || false
  : false;
export const isDarkMode = !isServer
  ? localStorage.getItem('editorDarkMode')
    ? localStorage.getItem('editorDarkMode') === 'true'
    : systemDarkMode
  : false;
